import { LayoutRoute, Route } from "@soft-db/typed-router";

const sitesRoutes = new LayoutRoute({
	path: "sites",
	name: "sites",
	component: () => import("@/pages/sites.vue"),
	meta: {
		feature: "site",
		permission: "site.get",
	},
	children: [
		new Route({
			path: "",
			component: () => import("@/pages/sites/index.vue"),
		}),
		new Route({
			path: ":id",
			component: () => import("@/pages/sites/_id.vue"),
			redirect: { name: "sites-id-settings" },
			meta: {
				permission: "site.update",
			},
			children: [
				new Route({
					path: "settings",
					component: () => import("@/pages/sites/_id/settings.vue"),
				}),
				new Route({
					path: "limits",
					component: () => import("@/pages/sites/_id/limits.vue"),
				}),
				new LayoutRoute({
					name: "site_alert",
					path: "alerts",
					children: [
						new Route({
							path: "",
							component: () => import("@/pages/sites/_id/alerts/index.vue"),
						}),
						new Route({
							path: ":alertid",
							component: () => import("@/pages/sites/_id/alerts/_alertid.vue"),
						}),
						new Route({
							path: ":alertid/creation",
							component: () => import("@/pages/sites/_id/alerts/alert-creation"),
						}),
					],
				}),
				new Route({
					meta: {
						softdBOnly: true,
					},
					path: "archive",
					component: () => import("@/pages/sites/_id/archive.vue"),
				}),
			],
		}),
	],
});

export default sitesRoutes;
